export const GAMMA_API_URL = "https://gamma-cache.polymarket.com";
export const CLOB_API_URL = "https://clob.polymarket.com";
